import 'rc-slider/assets/index.css';
import { type FC, memo } from 'react';
import RCSlider, { type SliderProps } from 'rc-slider';
import styles from './index.module.scss';

const Slider: FC<SliderProps<number>> = ({ className, ...props }) => {
  // @ts-expect-error
  return <RCSlider {...props} className={`${styles.slider} ${className}`} />;
};

export default memo(Slider);
